import { Pagination } from "./pagination.model";
import { Prestation } from "./prestation.model";

export class PrestationPage extends Pagination {
    content: Prestation[] = [];
  }